<template>
  <span class="badge" :style="{ backgroundColor: bg }">
    <el-icon :style="{ color }" class="fs-xxl"
      ><component :is="icon.collection"
    /></el-icon>
    <div class="extra" :style="{ borderLeftColor: bg }" />
  </span>
</template>

<script>
import { reactive } from 'vue'

import { Collection } from '@element-plus/icons-vue'

export default {
  components: {
    Collection
  },
  props: {
    text: {
      type: String,
      default: '<el-icon><collection /></el-icon>'
    },
    bg: {
      type: String,
      default: '#F6B326'
    },
    color: {
      type: String,
      default: '#fff'
    }
  },
  setup(props) {
    const data = {
      icon: {
        collection: 'collection'
      }
    }
    return reactive(data)
  }
}
</script>

<style lang="scss" scoped>
.badge {
  position: relative;
  padding: 0.625rem 0.375rem 0.1875rem;
  font-size: 1rem;
  border-radius: 2px;
  .extra {
    z-index: 1;
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    right: -0.375rem;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: 0.375rem solid transparent;
    border-top: 0.375rem solid transparent;
    border-left: 0.375rem solid #f6b326;
  }
}
</style>
